export default [
  {
    path: 'pto',
    name: 'PtoProjectPto',
    component: () => import('@/views/Pto/Project/pto/PtoProjectPto.vue'),
    redirect: {
      name: 'PtoProjectPtoJob'
    },
    children: [
      {
        path: 'job',
        name: 'PtoProjectPtoJob',
        component: () => import('@/views/Pto/Project/pto/PtoProjectPtoJob.vue')
      },
      {
        path: 'supply',
        name: 'PtoProjectPtoSupply',
        component: () => import('@/views/Pto/Project/pto/PtoProjectPtoSupply.vue')
      },
      {
        path: 'kmd',
        name: 'PtoProjectPtoKMD',
        component: () => import('@/views/Pto/Project/pto/PtoProjectPtoKMD.vue')
      },
      {
        path: 'cmk',
        name: 'PtoProjectPtoCMK',
        component: () => import('@/views/Pto/Project/pto/PtoProjectPtoCMK.vue')
      },
      {
        path: 'cmo',
        name: 'PtoProjectPtoCMO',
        component: () => import('@/views/Pto/Project/pto/PtoProjectPtoCMO.vue')
      },
      {
        path: 'pvh',
        name: 'PtoProjectPtoPVH',
        component: () => import('@/views/Pto/Project/pto/PtoProjectPtoPVH.vue')
      },
      {
        path: 'bru',
        name: 'PtoProjectPtoBRU',
        component: () => import('@/views/Pto/Project/pto/PtoProjectPtoBRU.vue')
      },
      {
        path: 'ppr',
        name: 'PtoProjectPtoPPR',
        component: () => import('@/views/Pto/Project/pto/PtoProjectPtoPPR.vue')
      },

      // Create
      {
        path: 'supply/create',
        name: 'PtoProjectPtoSupplyCreate',
        component: () => import('@/views/Pto/Project/pto/PtoProjectPtoSupplyCreate.vue')
      },

      // Detailed
      {
        path: 'job/:id',
        name: 'PtoProjectPtoJobUpdate',
        component: () => import('@/views/Pto/Project/pto/PtoProjectPtoJobUpdate.vue')
      },
      {
        path: 'planning/:id',
        name: 'PtoProjectPtoPlanningUpdate',
        component: () => import('@/views/Pto/Project/pto/PtoProjectPtoPlanningUpdate.vue')
      },
      {
        path: 'kmd/:id',
        name: 'PtoProjectPtoKMDUpdate',
        component: () => import('@/views/Pto/Project/pto/PtoProjectPtoKMDUpdate.vue')
      },
      {
        path: 'cmk/:id',
        name: 'PtoProjectPtoCMKUpdate',
        component: () => import('@/views/Pto/Project/pto/PtoProjectPtoCMKUpdate.vue')
      },
      {
        path: 'cmo/:id',
        name: 'PtoProjectPtoCMOUpdate',
        component: () => import('@/views/Pto/Project/pto/PtoProjectPtoCMOUpdate.vue')
      },
      {
        path: 'pvh/:id',
        name: 'PtoProjectPtoPVHUpdate',
        component: () => import('@/views/Pto/Project/pto/PtoProjectPtoPVHUpdate.vue')
      },
      {
        path: 'bru/:id',
        name: 'PtoProjectPtoBRUUpdate',
        component: () => import('@/views/Pto/Project/pto/PtoProjectPtoBRUUpdate.vue')
      },
      {
        path: 'nomenclature/:id',
        name: 'PtoProjectPtoNomenclatureUpdate',
        component: () => import('@/views/Pto/Project/pto/PtoProjectPtoNomenclatureUpdate.vue')
      },
      {
        path: 'ppr/:id',
        name: 'PtoProjectPtoPPRUpdate',
        component: () => import('@/views/Pto/Project/pto/PtoProjectPtoPPRUpdate.vue')
      },
      {
        path: 'supply/:id',
        name: 'PtoProjectPtoSupplyUpdate',
        component: () => import('@/views/Pto/Project/pto/PtoProjectPtoSupplyUpdate.vue'),
        redirect: {
          name: 'PtoProjectPtoNomenclature'
        },
        children: [
          {
            path: 'request',
            name: 'PtoProjectPtoSupplyRequest',
            component: () => import('@/views/Pto/Project/pto/PtoProjectPtoSupplyRequest.vue')
          },
          {
            path: 'nomenclature',
            name: 'PtoProjectPtoNomenclature',
            component: () => import('@/views/Pto/Project/pto/PtoProjectPtoNomenclature.vue')
          }
        ]
      },
      {
        path: 'supply-request/:id',
        name: 'PtoProjectPtoSupplyRequestUpdate',
        component: () => import('@/views/Pto/Project/pto/PtoProjectPtoSupplyRequestUpdate.vue')
      }
    ]
  }
]
